import React from "react";
import './SecondaryNav.css'

const SecondaryNav = ({ menus, activeMenu, setActiveMenu }) => {  
    const activate = (slug) => {
        return activeMenu === slug ? "secondary-nav-button active" : "secondary-nav-button";
    };

    return (
        <div>
            <div className="secondary-nav-buttons">
                {menus.map((c) => (
                    <button key={c.slug} onClick={() => setActiveMenu(c.slug)}
                        className={activate(c.slug)}>
                        {c.menu_text}
                    </button>
                ))}
            </div>           
        </div>
    );
};

export default SecondaryNav;
